export class CashbackRegionsEntity {
  regionId?: number
  districtIds?: Array<number> | null
  region?: {
    id?: number
    name?: string | null
  }
  districts?: Array<{
    id?: number
    name?: string | null
  }> | null
}
